import React, { createContext, useState } from 'react'

import DashboardMaster from '../../../../dashboard/DashboardMaster'
import { Card } from '../../../../components/ui/Card';
import { Button } from '../../../../components/ui/button';
import IconAdd from '../../../../components/svg/IconAdd';
import AnalyticsModel from './model/AnalyticsModel';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../../../components/ui/accordian';

export const AnalyticsContext = createContext(null);
const Analytics = () => {
  const [isModalShow, setIsModalShow] = useState(false);
  return (
    <DashboardMaster>
      <section className='p-2 md:px-5'>
        <Card className="bg-white p-3 md:p-5 ">
          <div className="content-head mb-6">
            <Button size="sm" className="h-[34px]" onClick={() => setIsModalShow(true)}>
              <span><IconAdd className="w-4 h-4" /></span> Add Analytics
            </Button>
            <AnalyticsModel show={isModalShow} onHide={() => setIsModalShow(false)} />
          </div>
          <div className="analytics-content-wrapper">
            <Accordion type="single" collapsible className="w-full rounded-none">
              <AccordionItem value="item-1" className="rounded-none border-none mb-4">
                <AccordionTrigger className="text-[13px] text-themeV2 font-500 capitalize px-4 py-3 shadow-accordian relative z-10 bg-backgroundV2">World Bank</AccordionTrigger>
                <AccordionContent className="border-none px-2 py-0 ">
                  <div className="bg-[#FBFBFB] shadow-common p-4">
                    {/* <WorldBankAnalyticsTable /> */}
                    WorldBankAnalyticsTable
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2" className="rounded-none border-none mb-4">
                <AccordionTrigger className="text-[13px] text-themeV2 font-500 capitalize px-4 py-3 shadow-accordian relative z-10 bg-backgroundV2">United Nations(SDGs)</AccordionTrigger>
                <AccordionContent className="border-none px-2 py-0 ">
                  <div className="bg-[#FBFBFB] shadow-common p-4">
                    {/* <UnitedNationAnalyticsTable /> */}
                    UnitedNationAnalyticsTable
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </Card>
      </section>
    </DashboardMaster>
  )
}

export default Analytics
